<template>
    <div>
        <div class="d-flex justify-content-start">
            <div class="file-data ml-1" v-if="canAdd===true" id="uploadFileBtn">
                <input type="file" multiple ref="fileInput" class="upload-file bg-magenta1-light shadow-s rounded-s text-center attListBtn" v-on:change="UploadFileList(1)" style="height:38px">
                <p class="upload-file-text text-center"><i class="fa fa-paperclip font-16"></i></p>
            </div>
            <div class="file-data ml-1" v-if="canAdd===true">
                <input v-if="isAndroid" type="file" accept="image/*" capture multiple ref="fileInput2" class="upload-file bg-magenta1-dark shadow-s rounded-s text-center attListBtn" v-on:change="UploadFileList(2)" style="height:38px">
                <p v-if="isAndroid" class="upload-file-text text-center"><i class="fa fa-camera font-16"></i></p>
            </div>
            <div class="ml-1" v-if="canAdd===true && hasLocation==true">
                <button type="button" class="bg-magenta2-light shadow-s rounded-s text-center attListBtn" style="height:38px" @click="ShowLocationModal(null)"><i class="fa fa-map-marked "></i></button>
            </div>

            <div class="d-flex justify-content-between ml-1" id="voiceRecord" v-if="canAdd===true">
                <button v-show="recordShow" class="btn btn-xxs bg-magenta2-dark rounded-s font-900 attListBtn" id="record" @click="onRecordButtonClick" title="ضبط صدا" type="button" style="height:38px">
                    <i class="fa fa-microphone"></i>
                </button>
                <button v-show="confirmRecordShow" class="btn btn-xxs bg-green1-dark rounded-s font-900 attListBtn" id="confirmRecord" type="button" @click.stop="onConfirmButtonClick">

                    <i class="fa fa-check"></i>
                </button>
                <div v-show="timerShow" id="timer">
                    <div class="d-flex justify-content-center align-items-center" style="height:38px;width:50px">
                        <span id="seconds">00</span>:<span id="minutes">00</span>
                    </div>
                </div>
                <button v-show="cancelRecordShow" class="btn btn-xxs bg-red1-dark rounded-s font-900 attListBtn" id="cancelRecord" type="button" @click.stop="onCancelButtonClick">

                    <i class="fa fa-times"></i>
                </button>
                <audio id="player" controls v-show="showPlayer"></audio>
            </div>

        </div>

        <div class="progress rounded-sm shadow-xl border border-fade-green1-dark my-3" v-show="showProgressBar" style="height:20px">
            <div class="progress-bar bg-green1-dark text-left pl-3 color-white" role="progressbar" id="progressBar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <div>
            <div v-if="waitCaption!=''">
                <div>{{waitCaption}}</div>
                <div>لطفا منتظر بمانید...</div>
            </div>
        </div>

        <div class="list-group list-custom-large upload-file-data mt-3">
            <div v-for="att in attList" :key="att.fileName" class="upload-file-data-item position-relative py-2">
                <span class="d-inline-flex align-items-center" v-if="att.fileName.includes('.mp3')">
                    <audio controls style="max-width:85%">
                        <source :src="att.fileName" type="audio/mp3">
                        <source :src="att.fileName" type="audio/webm">
                        <source :src="att.fileName" type="audio/ogg">
                    </audio>
                </span>
                <div v-else-if="att.fileName.includes('http')==false" @click="ShowLocationModal(att.fileName)" class="d-flex align-items-center border-0 list-custom-large-div">
                    <i class="fa font-14 fa-map-marker rounded-xl shadow-m bg-green1-dark m-0"></i>
                    <span class="d-inline-block font-weight-bold fileName-span text-overflow-ellipsis mr-2 pt-1">{{att.attDescription}}</span>
                </div>
                <div v-else @click="ShowFileInBrowser(att)" class="d-flex align-items-center border-0 list-custom-large-div w-100">
                    <i class="fa font-14 fa-file rounded-xl shadow-m bg-green1-dark"></i>
                    <div class="line-height-xs d-inline-block font-weight-bold fileName-span mr-2 pt-1 w-100 text-overflow-ellipsis">
                        {{att.attTitle}}
                        <div class="text-muted font-11 mt-2 rtl">حجم فایل: {{att.fileSize}} KB</div>
                        <div v-if="att.attCreatorUserTitle!=null && att.attCreatorUserTitle!=''" class="text-muted font-11 mt-2">
                            {{att.attCreatorUserTitle}} - <label class="m-0 d-inline-block ltr">{{att.createDateTimeFa}}</label>
                        </div>
                    </div>

                </div>


                <span class="badge bg-red2-dark mt-0" @click.prevent="DeleteAtt(att)" v-if="canDelete===true"><b class="fa fa-trash"></b></span>
                <!--<span class="badge badge2 bg-primary mt-0" @click.prevent="shareMedia(att)"><b class="fa fa-share-alt text-white"></b></span>-->
            </div>
        </div>

        <location-modal v-if="openLocationModal" :defaultLocation="selectedLocation" :defaultAddress="null" @SaveLocation="SaveLocation" @close="closeLocationModal"></location-modal>
    </div>

</template>
<script>
    import { Device } from '@capacitor/device';
    import { Browser } from '@capacitor/browser';
    import locationModal from './LocationModal.vue'
    import VueSimpleAlert from "vue3-simple-alert";
    export default {
        components: {
            "location-modal": locationModal,

        },
        props: ['destination', 'oldAttList', 'canAdd', 'canDelete', 'hideVoiceRecord', 'hasLocation', 'docId'],
        data() {
            return {
                file: null,
                fileList: [],
                attList: this.oldAttList,
                progress: 0,
                showProgressBar: false,
                timer: null,
                totalSeconds: 0,
                minutesLabel: 0,
                secondsLabel: 0,
                mediaRecorder: null,
                mediaStream: null,
                recordedBlobs: null,
                confirmRecordShow: false,
                cancelRecordShow: false,
                recordShow: true,
                timerShow: false,
                uploading: false,
                waitCaption: "",
                showPlayer: false,
                logDeviceInfo: null,
                openLocationModal: false,
                selectedLocation: null
            }
        },
        computed: {
            isAndroid() {
                return this.logDeviceInfo !== null && this.logDeviceInfo.operatingSystem === 'android';
            },

        },
        created() {
            this.GetDeviceInfo();
            //alert("");
            if (this.oldAttList !== null && this.oldAttList != []) {
                this.attList = this.oldAttList;
            }

        },
        methods: {
            async ShowFileInBrowser(att) {
                await Browser.open({ url: att.fileName });
            },
            async UploadFile(isVoice = false) {
                if (this.file.size > 10485760 && this.isMinVersion == true) {
                    this.showErrorMessage("امکان ثبت فایل پیوست بیشتر از 10 MB وجود ندارد.");
                    this.showProgressBar = false
                    this.$refs.fileInput.value = ""
                    this.$emit('attInProgress', false);
                    this.waitCaption = "";
                    return;
                }
                if (this.file.size > 52428800 && this.isMinVersion == false) {
                    this.showErrorMessage("امکان ثبت فایل پیوست بیشتر از 50 MB وجود ندارد.");
                    this.showProgressBar = false
                    this.$refs.fileInput.value = ""
                    this.$emit('attInProgress', false);
                    this.waitCaption = "";
                    return;
                }
                this.$emit('attInProgress', true);
                let formData = new FormData();
                formData.append('file', this.file)
                this.showProgressBar = true;
                this.waitCaption = "درحال ارسال فایل...";
                var response = await this.$http.post('Task/SaveAttFile?destination=' + this.destination + "&isVoice=" + isVoice + '&docId=' + this.docId, formData, {
                    progress(e) {
                        if (e.lengthComputable) {

                            this.progress = e.loaded / e.total * 100
                            this.progress = this.progress.toFixed(0);
                            if (this.progress == 100) {
                                this.waitCaption = "درحال ذخیره سازی فایل...";
                            }
                            var el = document.getElementById("progressBar")
                            el.style.width = this.progress + "%"
                            el.setAttribute("aria-valuenow", this.progress)
                            el.innerText = this.progress + "%"
                        }
                    }
                })

                if (response.data.success == true) {
                    this.attList.push(response.data)
                    this.$emit('setAttList', this.attList);

                }
                else {
                    this.showErrorMessage(response.data.message);
                }

                this.showProgressBar = false;
                this.$refs.fileInput.value = "";
                this.$emit('attInProgress', false);
                this.waitCaption = "";
                if (response.data.success == true && this.destination == "conversation" && this.docId != null && this.docId != 0) {
                    this.showSuccessMessage("با موفقیت بارگذاری شد");
                    window.location.reload();
                }

            },
            async UploadFileList(inputNum) {
                if (inputNum == 1) {
                    this.fileList = Array.from(this.$refs.fileInput.files)
                    console.log(this.fileList)
                }
                else {
                    this.fileList = Array.from(this.$refs.fileInput2.files)
                    console.log(this.fileList)
                }


                for (let i = 0; i < this.fileList.length; i++) {
                    this.file = this.fileList[i]
                    await this.UploadFile(false)
                }
            },
            DeleteAtt(att) {
                VueSimpleAlert.confirm("آیا مایل به حذف این فایل هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    if (this.destination == "TaskFolder") {
                        att.attId = att.taskFolderAttId
                    }
                    if (this.destination == "TaskWork") {
                        att.attId = att.taskWorkAttId
                    }
                    if (this.destination == "OtherWork") {
                        att.attId = att.otherWorkAttId
                    }
                    if (this.destination == "TaskNote") {
                        att.attId = att.noteAttId
                    }
                    if (this.destination == "UserPresence") {
                        att.attId = att.userPresenceAttId
                    }
                    if (this.destination == "WorkTimer") {
                        att.attId = att.folderAttId
                    }

                    this.$http.get("Task/DeleteAtt", {
                        params: {
                            id: att.attId, name: att.fileName, folder: this.destination
                        }
                    }).then(data => {
                        if (data.data == "1")
                            this.attList = this.attList.filter(function (el) { return el.fileName != att.fileName })
                        else {
                            VueSimpleAlert.alert(data.data, null, "warning", { confirmButtonText: "تایید" });
                        }
                    })
                })
            },
            //         shareMedia(att) {
            //	VueSimpleAlert.confirm("آیا مایل به اشتراک گذاری این فایل هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
            //                 const attUrl = att.fileName;
            //                 if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ||
            //                     (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.platform))) {
            //                     navigator.share({
            //                         title: 'به اشتراک گذاشتن فایل ' + att.fileName,
            //                         url: attUrl,
            //                     }).then(() => {
            //                         console.log('Thanks for sharing!');
            //                     })
            //                         .catch(console.error);
            //                 }
            //	})

            //},
            startRecording() {
                this.recordedBlobs = []

                try {
                    this.mediaRecorder = new MediaRecorder(this.mediaStream)
                } catch (e) {
                    console.error('Exception while creating MediaRecorder:', e)
                    return
                }
                this.mediaRecorder.onstop = (event) => {
                    console.log('Recorder stopped: ', event)
                    console.log('Recorded Blobs: ', this.recordedBlobs)

                }
                this.mediaRecorder.ondataavailable = this.handleDataAvailable
                this.mediaRecorder.start()
                console.log('MediaRecorder started', this.mediaRecorder)

            },
            stopRecording() {
                this.mediaRecorder.stop()
                this.stopTimer();
                this.$emit('attInProgress', false)
            },
            startTimer() {
                this.totalSeconds = 0
                clearInterval(this.timer)
                this.timer = setInterval(this.setTime, 1000)
                this.$emit('attInProgress', true);
            },
            stopTimer() {
                clearInterval(this.timer)
            },
            handleSuccess(stream) {
                this.recordShow = false
                console.log('getUserMedia() got stream:', stream)
                window.stream = stream
                this.mediaStream = stream
                this.confirmRecordShow = true
                this.cancelRecordShow = true
                this.recordShow = false
                this.timerShow = true
                this.startTimer()
                this.startRecording()
            },
            onRecordButtonClick() {
                const _this = this;
                navigator.mediaDevices.getUserMedia({ audio: true, video: false })
                    .then(data => { this.handleSuccess(data) }).catch(function () {
                        _this.showMessage("خطا در دسترسی به میکروفون! \n در صورتی که برنامه ی دیگری از میکروفون شما استفاده میکند لطفا ابتدا آن را بسته و مجددا تلاش کنید.")
                    })
            },
            onConfirmButtonClick() {
                this.uploading = true
                this.stopRecording()
                setTimeout(this.downloadRecord, 2000)
                this.confirmRecordShow = false
                this.cancelRecordShow = false
                this.recordShow = true
                this.timerShow = false
            },
            onCancelButtonClick() {
                this.stopRecording()

                this.confirmRecordShow = false
                this.cancelRecordShow = false
                this.recordShow = true
                this.timerShow = false
                this.minutesLabel = 0
                this.secondsLabel = 0

            },
            setTime() {
                this.totalSeconds++
                document.getElementById("seconds").innerHTML = this.pad(this.totalSeconds % 60)
                document.getElementById("minutes").innerHTML = this.pad(parseInt(this.totalSeconds / 60))
            },
            handleDataAvailable(event) {
                console.log('handleDataAvailable', event)
                if (event.data && event.data.size > 0) {
                    this.recordedBlobs.push(event.data)
                }
            },
            pad(val) {
                var valString = val + ""
                if (valString.length < 2) {
                    return "0" + valString
                } else {
                    return valString
                }
            },
            downloadRecord() {
                const blob = new Blob(this.recordedBlobs, { type: 'audio/mp3' })
                // const url = window.URL.createObjectURL(blob)
                this.file = blob
                this.UploadFile(true);

            },
            async GetDeviceInfo() {
                this.logDeviceInfo = await Device.getInfo();

            },
            ShowLocationModal(location) {
                this.selectedLocation = location;
                console.log(location);
                this.openLocationModal = true;
            },
            SaveLocation(att) {
                var exist = this.attList.filter(x => x.fileName == att.fileName);
                console.log(exist);
                if (exist.length > 0) {
                    this.showErrorMessage("موقعیت مکانی ثبت شده تکراری است!");
                    return;
                }
                this.attList.push(att);
                this.openLocationModal = false;
                this.$emit('setAttList', this.attList);
            },
            closeLocationModal() {
                this.openLocationModal = false;
            }


        },
        mounted: function () {
            this.$nextTick(function () {
                if (window.location.href.includes("UserPresence") || window.location.href.includes("CreateUserPresence") || window.location.href.includes("EditUserPresence") || window.location.href.includes("ShowUsersOnMap")) {
                    document.getElementById('uploadFileBtn').remove();
                }
            })
            //            alert(this.docId);
        }

    }
</script>
<style>
    #cancelRecord {
        font-size: 16px !important
    }

    #confirmRecord {
        font-size: 16px !important
    }
</style>